import { Head, Link, Form as InertiaForm } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import { Label } from "@/components/ui/label.tsx";

type SessionNewProps = {
  email?: string;
  rememberable: boolean;
  recoverable: boolean;
};

const New = ({ email, rememberable, recoverable }: SessionNewProps) => {
  return (
    <>
      <Head title="Connexion" />




      <div className="space-y-6">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.35em] text-muted-foreground">Bienvenue</p>
          <h1 className="text-3xl font-semibold">Se connecter</h1>
          <p className="text-sm text-muted-foreground">
            Accedez a votre espace de gestion Taxio.
          </p>
        </div>

        <InertiaForm
          method="post"
          action="/users/sign_in"
          transform={(data) => ({ user: data })}
          className="space-y-4"
        >
          {({ errors, processing }) => (
            <>
              <div className="space-y-2">
                <Label htmlFor="email">Adresse email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  autoFocus
                  required
                  placeholder="prenom.nom@taxio.app"
                  defaultValue={email || ""}
                />
                {errors.email && (
                  <p className="text-xs text-red-500">{errors.email.join(", ")}</p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Mot de passe</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  placeholder="Votre mot de passe"
                />
                {errors.password && (
                  <p className="text-xs text-red-500">{errors.password.join(", ")}</p>
                )}
              </div>

              {rememberable && (
                <label className="flex items-center gap-2 text-sm text-muted-foreground">
                  <input
                    type="checkbox"
                    name="remember_me"
                    className="h-4 w-4 rounded border-border text-primary focus:ring-primary"
                  />
                  Se souvenir de moi
                </label>
              )}

              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Connexion..." : "Se connecter"}
              </Button>
            </>
          )}
        </InertiaForm>

        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>Acces reserve au personnel autorise.</span>
          {recoverable && (
            <Link href="/users/password/new" className="text-primary hover:underline">
              Mot de passe oublie
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

New.layout = (page: React.ReactNode) => <AuthLayout>{page}</AuthLayout>;

export default New;
